// =============================================================================
// Referral code format
// =============================================================================
/**
 * Crockford base32 without I, L, O and U: no character a person can mistake
 * for another when reading a code aloud or typing it from a printed link.
 */
export const REFERRAL_CODE_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
/** The length of a newly minted code. */
export const REFERRAL_CODE_LENGTH = 6;
/**
 * The lengths accepted on input. Wider than `REFERRAL_CODE_LENGTH` so that
 * lengthening minted codes later does not strand links already shared.
 */
const REFERRAL_CODE_MIN_INPUT_LENGTH = 4;
const REFERRAL_CODE_MAX_INPUT_LENGTH = 12;
const REFERRAL_CODE_INPUT_PATTERN = new RegExp(`^[${REFERRAL_CODE_ALPHABET}]{${REFERRAL_CODE_MIN_INPUT_LENGTH},${REFERRAL_CODE_MAX_INPUT_LENGTH}}$`);
/**
 * Trim and upper-case a code, then return it only if it is a plausible code:
 * characters from the alphabet, 4 to 12 of them. Anything else is `null`, which
 * both the backend and the Bill capture treat as "not a referral code".
 */
export function normaliseReferralCode(input) {
    const candidate = input.trim().toUpperCase();
    return REFERRAL_CODE_INPUT_PATTERN.test(candidate) ? candidate : null;
}
